import { io, Socket } from "socket.io-client";

// ----------------------------- Base Urls ----------------------------------
const SOCKET_SERVER_URL = process.env["REACT_APP_SERVER_BASE_URL"]; // Backend URL


export const initializeSocket = (user_uuid?: string, role_value?: string): Socket => {
    const socketOptions: any = {
        autoConnect: false, // Prevent automatic connection
        transports: ['websocket', 'polling'], // Allow both transports
    };
    
    // Only add auth if user_uuid is provided (for activation, we don't need auth)
    if (user_uuid) {
        socketOptions.auth = {
            user_uuid
        };
    }

    if (role_value) {
        socketOptions.auth = {
            role_value
        };
    }
    
    const app_socket = io(SOCKET_SERVER_URL, socketOptions);
    app_socket.connect();
    return app_socket;
};


// const disconnectSocket = () => {
//     if (app_socket) {
//         app_socket.disconnect();
//         app_socket = null;
//     }
// };